import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {debounce} from "../../../utils/debounce";

import MDInput from "materialDashboard/components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import {getScrollHandler, LoadingAdornment} from "../utils";
import {useGroupInfiniteQuery} from "./query";


const GroupsAutocomplete = ({ workgroupIds, selectedGroups, setSelectedGroups, fieldProps={}, ...props }) => {
    const {t} = useTranslation(["inputs"]);

    const [hasFocus, setHasFocus] = useState(false);
    const [groupSearch, setGroupSearch] = useState("");
    let groupFilter = {search: groupSearch}
    if(workgroupIds?.length > 0){
        groupFilter = {...groupFilter, workgroup__id__in: workgroupIds}
    }
    const groupSearchQuery = useGroupInfiniteQuery(groupFilter, hasFocus);

    const groupOptions = [
        ...selectedGroups,
        ...(groupSearchQuery.data?.pages?.flatMap((page) => page.items) ?? []).filter((w) => !selectedGroups.find(({id}) => id === w.id)),
    ]

    const handleGroupSearch = debounce((value) => {
        setGroupSearch(value);
    }, 300);

    return <Autocomplete
        multiple
        id="group-autocomplete"
        options={groupOptions}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(group) => group.name}
        value={selectedGroups}
        defaultValue={selectedGroups}
        filterOptions={(x) => x}
        loading={groupSearch.isFetching}
        onChange={(e, value) => setSelectedGroups(value)}
        onClose={() => handleGroupSearch("")}
        onFocus={() => setHasFocus(true)}
        onBlur={() => setHasFocus(false)}
        ListboxProps={{onScroll: getScrollHandler(groupSearchQuery)}}
        renderInput={(params) => (
            <MDInput {...params}
                     onChange={(e) => handleGroupSearch(e.target.value)}
                     variant="standard"
                     label={t('groupsAutocomplete.label')}
                     placeholder={t('groupsAutocomplete.placeholder')}
                     InputProps={{
                         ...params.InputProps,
                         endAdornment: (<LoadingAdornment infiniteQuery={groupSearchQuery} params={params} /> ),
                     }}
                     {...fieldProps}
            />
        )}
        {...props}
    />
}

export default GroupsAutocomplete;